<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="账号:">
          <el-input v-model.trim="searchForm.username"
                    placeholder="账号">
          </el-input>
        </el-form-item>
        <el-form-item label="时间:">
          <el-date-picker v-model="searchForm.time"
                          value-format="yyyy-MM-dd"
                          type="daterange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">
            查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                style="width: 100%">
        <el-table-column type="index"
                         label="序号"
                         width="60">
        </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'createTime'">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { Pagination },
  data() {
    return {
      searchForm: {
        username: '',
        time: ''
      },
      tableTitle: [
        {
          prop: 'username',
          name: '账号',
          width: '100'
        },
        {
          prop: 'fullname',
          name: '姓名',
          width: '100'
        },
        {
          prop: 'role_name',
          name: '角色',
          width: '100'
        },
        {
          prop: 'timestamp',
          name: '时间',
          width: '120'
        },
        {
          prop: 'action_name',
          name: '操作',
          width: '100'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      const { currentPage, perPage } = this.pagination
      let data = {
        currentPage: currentPage,
        perPage: perPage,
        username: this.searchForm.username,
        startTime: this.searchForm.time ? this.searchForm.time[0] : '',
        endTime: this.searchForm.time ? this.searchForm.time[1] : ''
      }
      fetch.getSysLogList(data).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.pagination.total = Number(data.total)
            this.tableData = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped></style>
